/**
 * FWD检测数据管理 API
 */
import { gapiRequest } from './request'
import type {
  FwdRaw,
  FwdRawCreateRequest,
  FwdRawUpdateRequest,
  FwdRawQueryParams,
  FwdRawMapQueryParams,
  FwdRawListResponse,
  FwdRawImportResult,
  FwdRatingConfigResponse,
} from '@/types/fwdRaw'

export const fwdRawApi = {
  // 获取列表
  getList: (params: FwdRawQueryParams) =>
    gapiRequest.get<any, FwdRawListResponse>('/v1/fwd-raw', { params }),

  // 地图需要完整点集；后端列表单页上限为 100，这里自动翻页聚合。
  getMapList: async (params: FwdRawMapQueryParams = {}): Promise<FwdRawListResponse> => {
    const list: FwdRaw[] = []
    let total = 0
    let page = 1

    do {
      const response = await gapiRequest.get<any, FwdRawListResponse>('/v1/fwd-raw', {
        params: {
          ...params,
          page,
          page_size: 100,
        },
      })
      const pageList = response.list || []
      total = response.total || 0
      list.push(...pageList)
      if (pageList.length === 0) break
      page += 1
    } while (list.length < total)

    return { total, list }
  },

  // 获取指标评级阈值（Strong/Moderate/Weak）；前端着色以此为权威源，不再硬编码
  getRatingConfig: () =>
    gapiRequest.get<any, FwdRatingConfigResponse>('/v1/fwd-raw/rating-config'),

  // 获取详情（通过uuid）
  getByUuid: (uuid: string) =>
    gapiRequest.get<any, FwdRaw>(`/v1/fwd-raw/${uuid}`),

  // 创建
  create: (data: FwdRawCreateRequest) =>
    gapiRequest.post<any, FwdRaw>('/v1/fwd-raw', data),

  // 更新（通过uuid）
  update: (uuid: string, data: FwdRawUpdateRequest) =>
    gapiRequest.put<any, FwdRaw>(`/v1/fwd-raw/${uuid}`, data),

  // 删除（通过uuid）
  delete: (uuid: string) =>
    gapiRequest.delete<any, void>(`/v1/fwd-raw/${uuid}`),

  // 下载导入模板
  downloadTemplate: () => {
    return gapiRequest.get<any, Blob>('/v1/fwd-raw/template', {
      responseType: 'blob'
    }).then(blob => {
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', 'fwd_raw.xlsx')
      document.body.appendChild(link)
      link.click()
      link.remove()
      window.URL.revokeObjectURL(url)
    })
  },

  // 批量导入。源表无时间列，collectTime 由用户在导入弹窗中选择后一并提交
  importFromFile: (file: File, collectTime: string) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('collect_time', collectTime)
    return gapiRequest.post<any, FwdRawImportResult>(
      '/v1/fwd-raw/import',
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    )
  },
}
